import type { Locale } from '$lib/i18n/types';
import { magazineUrlByLocale } from '$lib/services/advertising/magazine';

export const contactLinkPerLocale: Record<Locale, string> = {
	'fr-FR': `${magazineUrlByLocale['fr-FR']}contact/`,
	'fr-BE': `${magazineUrlByLocale['fr-BE']}contact/`,
	'fr-CH': `${magazineUrlByLocale['fr-CH']}contact/`,
	'en-GB': `${magazineUrlByLocale['en-GB']}contact-us/`,
	'en-IE': `${magazineUrlByLocale['en-IE']}contact-us/`,
	'en-US': `${magazineUrlByLocale['en-US']}contact-us/`,
	'de-AT': `${magazineUrlByLocale['de-AT']}kontaktieren-sie-uns/`,
	'de-CH': `${magazineUrlByLocale['de-CH']}kontaktieren-sie-uns/`,
	'de-DE': `${magazineUrlByLocale['de-DE']}kontaktieren-sie-uns/`,
	'it-CH': `${magazineUrlByLocale['it-CH']}contattaci/`,
	'it-IT': `${magazineUrlByLocale['it-IT']}contattaci/`,
	'es-ES': `${magazineUrlByLocale['es-ES']}contacta-con-nosotros/`,
	'nl-BE': `${magazineUrlByLocale['nl-BE']}contact-us/`,
	'nl-NL': `${magazineUrlByLocale['nl-NL']}contact-us/`,
	'pt-PT': `${magazineUrlByLocale['pt-PT']}contact-us/`,
};
